export default __webpack_public_path__ + "static/logo-e1074ab2487d3f7c2c06e1d7fa746b91.png";